import { useContent } from "../App";
import { CheckCircle, Leaf } from "lucide-react";
import { usePageSEO } from "../hooks/usePageSEO";

export default function DiningPage() {
  const { content } = useContent();

  usePageSEO({
    title: "Dining Area | Ambe Palace - Best Hotel & Restaurant in Dungarpur",
    description: "Enjoy delicious pure vegetarian meals at Ambe Palace dining area in Dungarpur. Clean dining environment, freshly prepared food, and family-friendly atmosphere."
  });

  const dining = content.dining || {
    title: "Dining Area",
    text: "Ambe Palace offers a comfortable dining area where guests can enjoy delicious pure vegetarian meals with family and friends.",
    highlights: ["Clean dining environment", "Freshly prepared food", "Family friendly atmosphere"],
    images: [
      "https://customer-assets.emergentagent.com/job_ambe-rooms-1/artifacts/o3dakqvf_IMG_20260316_003839.jpg",
      "https://customer-assets.emergentagent.com/job_ambe-rooms-1/artifacts/100xf7ss_IMG_20260316_003812.jpg"
    ]
  };

  return (
    <div data-testid="dining-page">
      <section className="bg-slate-900 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400 mb-4 block">Experience</span>
          <h1 className="text-4xl sm:text-5xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
            Dining Area {'\u2014'} Ambe Palace Dungarpur
          </h1>
          <div className="flex items-center justify-center gap-2 mt-4">
            <Leaf className="w-4 h-4 text-green-400" />
            <span className="text-sm text-green-400 font-semibold">Pure Vegetarian</span>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {dining.images?.map((img, i) => (
              <div key={i} className="img-zoom overflow-hidden aspect-[4/3]" data-testid={`dining-image-${i}`}>
                <img src={img} alt={`Ambe Palace dining area in Dungarpur Rajasthan - image ${i + 1}`} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            {dining.title}
          </h2>
          <div className="w-16 h-[3px] bg-amber-600 mx-auto mb-8" />
          <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-12">
            {dining.text}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {dining.highlights?.map((h, i) => (
              <div key={i} className="bg-white border border-stone-100 p-6 text-center" data-testid={`dining-highlight-${i}`}>
                <CheckCircle className="w-8 h-8 text-amber-600 mx-auto mb-3" />
                <p className="text-sm font-bold text-slate-800 uppercase tracking-wider">{h}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
